import * as React from 'react';

import { cn } from '@/lib/utils';

const Textarea = ({ className, ...props }: React.ComponentProps<'textarea'>) => {
  return (
    <textarea
      className={cn(
        'flex min-h-16 w-full rounded border resize-none border-input bg-transparent px-3 py-2 shadow-xs placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:bg-muted text-control font-medium',
        className,
      )}
      {...props}
    />
  );
};

export { Textarea };
